// extracted by css-extract-rspack-plugin
export default {"logobarTopBorder":"FlexSuiteIntroLogos-module__logobarTopBorder__OZG71"};